'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./enums-de2d9d36.js');
var paper = require('./paper-e6cfe656.js');
require('moment');
var calendar$1 = require('./calendar-4ded34ed.js');
var filterButtons = require('./filter-buttons-dd2abc5c.js');
var useTableContext_hook = require('./useTableContext.hook-ec1eae40.js');

var alignmentStyles = {
    left: styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    left: -50px;\n  "], ["\n    left: -50px;\n  "]))),
    right: styled.css(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    right: -50px;\n  "], ["\n    right: -50px;\n  "]))),
};
var CalendarContainer = styled__default(paper.Paper)(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  margin-top: 11px;\n  width: auto;\n  height: auto;\n  position: absolute;\n  right: auto;\n  left: auto;\n  top: 100%;\n  z-index: 1;\n  background-color: ", ";\n\n  ", ";\n\n  .table-calendar {\n    position: relative;\n  }\n"], ["\n  margin-top: 11px;\n  width: auto;\n  height: auto;\n  position: absolute;\n  right: auto;\n  left: auto;\n  top: 100%;\n  z-index: 1;\n  background-color: ", ";\n\n  ", ";\n\n  .table-calendar {\n    position: relative;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.universal.white;
}, function (_a) {
    var _b = _a.calendarAlignment, calendarAlignment = _b === void 0 ? 'left' : _b;
    return alignmentStyles[calendarAlignment];
});
var StyledFilterButtons = styled__default(filterButtons.FilterButtons)(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  padding: 16px 20px;\n  border-top: 1px solid ", ";\n"], ["\n  padding: 16px 20px;\n  border-top: 1px solid ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyLight;
});
var FilterCalendar = function (_a) {
    var _b = _a.calendarAlignment, calendarAlignment = _b === void 0 ? 'left' : _b, dateValue = _a.dateValue, onChange = _a.onChange, calendarRef = _a.calendarRef, locale = _a.locale, rest = tslib_es6.__rest(_a, ["calendarAlignment", "dateValue", "onChange", "calendarRef", "locale"]);
    var version = useTableContext_hook.useTableContext().version;
    return (React__default.createElement(CalendarContainer, { depth: 2, borderRadius: "sm", ref: calendarRef, calendarAlignment: calendarAlignment, className: "menu-calendar " + calendarAlignment },
        React__default.createElement(calendar$1.Calendar, { value: dateValue, onChange: onChange, dataCy: "cell-calendar-view", dataTestId: "cell-calendar-view", size: "xs", variant: "secondary", locale: locale, showCurrentDate: true }),
        version === 1 && React__default.createElement(StyledFilterButtons, tslib_es6.__assign({}, rest))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

exports.FilterCalendar = FilterCalendar;
